/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';

import {
    Input,
    Spin,
    Form,
    Card,
    Button,
    message,
    Upload,
    Icon,
    Select,
    Modal as AntModal,
} from 'antd';
import './index.less';
import { services } from '@comall-backend-builder/core';
import { LinkType } from '../../design_page/components/tools';
import { SIDEBARMENU_TYPE_LIST } from '../../constants/page-design';
import { customSelectorConfig } from '../../design';
import { isArray, isObject } from 'lodash';
import moment from 'moment';
import { errorHandle } from '../../services';
const { TextArea } = Input;
const { Option } = Select;

const SidebarMenuDetailCom: React.FC<any> = ({ form, params = {} }) => {
    const [spinning, setSpinning] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState<any>([]);
    const [backPic, setBackPic] = useState(''); // 图片地址
    const [jumpUrl, setJumpUrl] = useState<any>({
        linkType: 'none',
        linkParams: '',
    });
    const id = params.id ?? '';

    const isJSON = (str: string) => {
        try {
            JSON.parse(str);
            return true;
        } catch (error) {
            return false;
        }
    };

    const handleGetDetail = () => {
        setSpinning(true);
        services.api
            .get({}, { apiPath: `/appletTab/${id}` })
            .then((res: any) => {
                const { img, linkType, linkTarget, makeDate } = res;
                const formData = { ...res };
                if (makeDate) {
                    formData.makeDate = moment(makeDate).format('YYYY-MM-DD');
                }
                form.setFieldsValue({ ...formData });
                const fileListData = img
                    ? [{ uid: '-1', name: '浮层.png', status: 'done', url: img }]
                    : [];
                setFileList(fileListData);
                setBackPic(img);
                const jumpUrlData = {
                    linkType: linkType,
                    linkParams: linkTarget,
                };
                if (linkTarget && isJSON(linkTarget)) {
                    jumpUrlData.linkParams = JSON.parse(linkTarget);
                }
                setJumpUrl(jumpUrlData);
            })
            .catch((e: any) => {
                errorHandle(e);
            })
            .finally(() => {
                setSpinning(false);
            });
    };

    useEffect(() => {
        if (id) {
            handleGetDetail();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        form.validateFields((_err: any, values: any) => {
            const { linkType, linkParams } = jumpUrl;
            const serveParams = {
                ...values,
                img: backPic,
                linkType,
                linkTarget: isObject(linkParams) ? JSON.stringify(linkParams) : linkParams,
            };
            delete serveParams.makeDate;
            if (!id) {
                services.api
                    .post({ ...serveParams }, { apiPath: `/appletTab` })
                    .then(() => {
                        message.success('新增成功！');
                        goBack();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            } else {
                services.api
                    .put({ ...serveParams }, { apiPath: `/appletTab/${id}/updateAppletTab` })
                    .then(() => {
                        message.success('新增成功！');
                        goBack();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            }
        });
    };

    const goBack = () => {
        services.navigation.goto('/design/sidebarMenu');
    };

    const handlePreview = async (e: any) => {
        setPreviewImage(e.url || e.thumbUrl);
        setShowPreview(true);
    };

    const handleChange = (e: any) => {
        if (e.file.status === 'done') {
            message.success('上传成功1个，上传失败0个');
        } else if (e.file.status === 'error') {
            message.success('上传成功0个，上传失败1个');
        }
        setFileList(e.fileList);
        if (isArray(e.fileList) && e.fileList.length) {
            const cur = e.fileList[0] || {};
            const path = cur?.response?.path;
            setBackPic(path);
        } else {
            setTimeout(() => {
                form.setFieldsValue({ imgUrl: undefined });
            }, 20);
            console.log(e.fileList, 'e.fileList');
        }
    };

    const uploadButton = (
        <div>
            <Icon type="plus" />
            <div className="ant-upload-text">上传</div>
        </div>
    );

    const uploadMsg = (
        <div className="uploadMsg">
            <span>支持jpg/png/gif 格式，图片尺寸建议为</span>
            <br />
            <span>180px*180px</span>
        </div>
    );

    const handleChangePath = (path: any) => {
        setJumpUrl(path);
    };

    const selector: any = customSelectorConfig;

    const { getFieldDecorator } = form;

    return (
        <>
            <Card title="查看tab内容">
                <Spin spinning={spinning}>
                    <div className="sidebar-add-box">
                        <Form
                            className="ant-advanced-search-form"
                            style={{ marginBottom: '24px' }}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 12 }}
                            onSubmit={handleSubmit}
                        >
                            <Form.Item label="名称">
                                {getFieldDecorator('name', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入TAB名称',
                                        },
                                    ],
                                })(<Input disabled={true} />)}
                            </Form.Item>
                            <Form.Item label="创建日期">
                                {getFieldDecorator('makeDate')(<Input disabled />)}
                            </Form.Item>
                            <Form.Item label="目标描述">
                                {getFieldDecorator('content', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入目标描述',
                                        },
                                    ],
                                })(<TextArea disabled={true} rows={4} />)}
                            </Form.Item>
                            <div className="upload-image">
                                <Form.Item label="图片">
                                    {getFieldDecorator('img', {
                                        rules: [{ required: true, message: '请上传图片' }],
                                    })(
                                        <Upload
                                            disabled={true}
                                            accept="image/*"
                                            name="fileName"
                                            action={`${ENV.API_ROOT}/images`}
                                            listType="picture-card"
                                            fileList={fileList}
                                            // beforeUpload={handleBeforeUpload}
                                            onPreview={handlePreview}
                                            onChange={handleChange}
                                        >
                                            {fileList.length >= 1 ? null : uploadButton}
                                        </Upload>
                                    )}
                                    {uploadMsg}
                                </Form.Item>
                            </div>

                            <div style={{ marginBottom: 16 }} className="linkType-box">
                                <LinkType
                                    selector={selector}
                                    linkTypes={SIDEBARMENU_TYPE_LIST}
                                    linkTypeMode="select"
                                    value={jumpUrl}
                                    onChange={(path: any) => handleChangePath(path)}
                                    disabled={true}
                                />
                            </div>

                            <Form.Item label="使用页面">
                                {getFieldDecorator('position', {
                                    rules: [{ required: true, message: '选择页面使用位置' }],
                                })(
                                    <Select mode="multiple" disabled={true}>
                                        <Option value="home">首页</Option>
                                        <Option value="productClassify">商品分类</Option>
                                        <Option value="productList">商品列表</Option>
                                        <Option value="activity">活动专题页</Option>
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item
                                style={{ marginTop: 36 }}
                                wrapperCol={{ span: 12, offset: 9 }}
                            >
                                <Button style={{ marginLeft: 12 }} onClick={goBack}>
                                    返回
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Spin>

                <AntModal
                    visible={showPreview}
                    footer={null}
                    width={500}
                    style={{ textAlign: 'center' }}
                    onCancel={() => {
                        setShowPreview(false);
                        setPreviewImage('');
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <img style={{ width: '100%' }} src={previewImage} alt="" />
                    </div>
                </AntModal>
            </Card>
        </>
    );
};

export const SidebarMenuDetail = Form.create<any>()(SidebarMenuDetailCom);
export default SidebarMenuDetail;
